import React from 'react';

const AutopayEmptyIcon = () => {
  return (
    <svg width="250" height="120" viewBox="0 0 250 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M136 25C139.866 25 143 28.134 143 32C143 35.866 139.866 39 136 39H200C203.866 39 207 42.134 207 46C207 49.866 203.866 53 200 53H222C225.866 53 229 56.134 229 60C229 63.866 225.866 67 222 67H203C199.134 67 196 70.134 196 74C196 77.866 199.134 81 203 81H209C212.866 81 216 84.134 216 88C216 91.866 212.866 95 209 95H157C156.485 95 155.983 94.9444 155.5 94.8389C155.017 94.9444 154.515 95 154 95H63C59.134 95 56 91.866 56 88C56 84.134 59.134 81 63 81H24C20.134 81 17 77.866 17 74C17 70.134 20.134 67 24 67H64C67.866 67 71 63.866 71 60C71 56.134 67.866 53 64 53H39C35.134 53 32 49.866 32 46C32 42.134 35.134 39 39 39H79C75.134 39 72 35.866 72 32C72 28.134 75.134 25 79 25H136ZM226 81C229.866 81 233 84.134 233 88C233 91.866 229.866 95 226 95C222.134 95 219 91.866 219 88C219 84.134 222.134 81 226 81Z"
        fill="#ECEFF1"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.952 35.5174L152.977 22.2257C154.613 21.9637 156.151 23.0777 156.413 24.7137C156.414 24.717 156.414 24.7203 156.415 24.7235L164.537 76.5556C164.793 78.1887 163.679 79.721 162.047 79.9823L79.0222 93.274C77.3862 93.5359 75.8476 92.422 75.5857 90.786C75.5852 90.7827 75.5847 90.7794 75.5841 90.7762L67.4624 38.9441C67.2065 37.311 68.3198 35.7787 69.952 35.5174Z"
        fill="white"
      />
      <path
        d="M83.3448 92.4234L80.1615 92.9482C77.9748 93.3085 75.9214 91.756 75.575 89.4805L68.0499 40.0391C67.7036 37.7636 69.1955 35.6268 71.3822 35.2664L151.558 22.0519C153.745 21.6916 155.798 23.2441 156.145 25.5196C156.482 27.7367 156.751 29.5036 156.952 30.8203M157.523 34.5758C157.705 35.7685 157.864 36.8129 158 37.7091"
        stroke="#90A4AE"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.977 37.7922L149.737 25.9612C151.369 25.7063 152.9 26.8186 153.162 28.4494L160.522 74.2685C160.785 75.9043 159.672 77.4435 158.036 77.7063C158.032 77.707 158.027 77.7077 158.023 77.7083L82.2629 89.5394C80.631 89.7943 79.1 88.682 78.838 87.0511L71.4779 41.2321C71.2151 39.5962 72.3282 38.0571 73.9641 37.7943C73.9684 37.7936 73.9727 37.7929 73.977 37.7922Z"
        fill="#ECEFF1"
      />
      <path
        d="M170.75 42.25H92.25C90.0409 42.25 88.25 44.0409 88.25 46.25V94.75C88.25 96.9591 90.0409 98.75 92.25 98.75H170.75C172.959 98.75 174.75 96.9591 174.75 94.75V46.25C174.75 44.0409 172.959 42.25 170.75 42.25Z"
        fill="white"
        stroke="#90A4AE"
        strokeWidth="2.5"
      />
      <path d="M173.5 54H89.5V68H173.5V54Z" fill="#ECEFF1" />
      <path
        d="M174.172 54H108.331M168.172 67H89.332M125.063 86H96.7551M103.29 54H96.0931"
        stroke="#90A4AE"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AutopayEmptyIcon;
